module.exports = __webpack_public_path__ + "img/trotairidea.d37212af.png";